import React from "react";
import { Card } from "antd";
import vendorImg from '../../../../Assets/SVG/total-vendors.svg';
import staffsImg from '../../../../Assets/SVG/total-staff.svg';
import guestImg from '../../../../Assets/SVG/total-guests.svg';
import visitorsImg from '../../../../Assets/SVG/total-visitors.svg';
interface StatCardProps {
  data: {
    totalVisitors: number;
    totalStaffs: number;
    totalVendors: number;
    totalGuests: number;
  }
}

export const StatCard: React.FC<StatCardProps> = ({ data }) => {
  const stats = [
    { title: 'Total Visitors', count: data.totalVisitors, img: visitorsImg },
    { title: 'Total Guests', count: data.totalGuests, img: guestImg },
    { title: 'Total Staffs', count: data.totalStaffs, img: staffsImg },
    { title: 'Total Vendors', count: data.totalVendors, img: staffsImg },
  ];
  return (
    <>
    {stats.map((stat, index) => (
    <Card 
    className="p-6 shadow-lg flex flex-col sm:flex-row items-center sm:items-start h-auto !rounded-2xl hover:shadow-xl transition-shadow duration-300 max-w-md mb-6"
    >
    <div className="flex sm:flex-row flex-col sm:justify-between w-full h-full">
      <div className="mb-4 sm:mb-0 sm:mr-6 flex justify-center sm:justify-start h-full">
      <Card
        className="w-20 h-20 !rounded-lg flex items-center justify-center"
        style={{background:'#F9ECFF'}}
        bodyStyle={{ backgroundColor: '#F9ECFF', padding: 0, border: 'none' }}
      >
        <img
          src={stat.img}
          alt={stat.title}
          className="w-[50px] h-[50px] object-cover rounded-lg"
        />
      </Card>
    </div>
      <div className="flex flex-col justify-between sm:items-start text-center sm:text-left flex-grow">
        <span className="text-lg sm:text-xl break-words mb-4">{stat.title}</span>
        <span className="text-3xl font-bold" style={{ color: '#712B90' }}>
          {stat.count}
        </span>
      </div>
    </div>
  </Card>
 ))}
 </>
  );
};